// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-page {
  padding-top: 32px;
  padding-bottom: 48px;
}

.info-page__card {
  background: #ffffff;
  border: 1px solid #e8e4df;
  border-radius: 20px;
  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.08);
  padding: 28px 32px;
  color: #4e3f3a;
}

.info-page__title {
  margin: 0 0 16px 0;
  font-family: 'Neucha', cursive;
  font-size: 48px;
  line-height: 1;
  font-weight: 400;
  color: #4e3f3a;
}

.info-page__lead {
  margin-top: 0;
  font-weight: 600;
}

.info-page__motto {
  margin-bottom: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.info-page__block + .info-page__block {
  margin-top: 24px;
}

.info-page__block h2 {
  margin: 0 0 8px 0;
  font-family: 'Neucha', cursive;
  font-size: 34px;
  font-weight: 400;
}

.info-page__block p {
  margin: 0 0 8px 0;
}

.info-page__block p:last-child {
  margin-bottom: 0;
}

.info-page__block a {
  color: #fc761f;
}

.info-page__list {
  margin: 0;
  padding-left: 20px;
  display: grid;
  gap: 6px;
}

@media (max-width: 768px) {
  .info-page {
    padding-top: 20px;
    padding-bottom: 28px;
  }

  .info-page__card {
    border-radius: 14px;
    padding: 18px 16px;
  }

  .info-page__title {
    font-size: 38px;
    margin-bottom: 12px;
  }

  .info-page__motto {
    font-size: 18px;
  }

  .info-page__block h2 {
    font-size: 30px;
  }
}

@media (max-width: 430px) {
  .info-page__title {
    font-size: 32px;
  }

  .info-page__motto {
    font-size: 16px;
  }

  .info-page__block h2 {
    font-size: 26px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/InfoPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".info-page {\n  padding-top: 32px;\n  padding-bottom: 48px;\n}\n\n.info-page__card {\n  background: #ffffff;\n  border: 1px solid #e8e4df;\n  border-radius: 20px;\n  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.08);\n  padding: 28px 32px;\n  color: #4e3f3a;\n}\n\n.info-page__title {\n  margin: 0 0 16px 0;\n  font-family: 'Neucha', cursive;\n  font-size: 48px;\n  line-height: 1;\n  font-weight: 400;\n  color: #4e3f3a;\n}\n\n.info-page__lead {\n  margin-top: 0;\n  font-weight: 600;\n}\n\n.info-page__motto {\n  margin-bottom: 0;\n  font-size: 22px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.info-page__block + .info-page__block {\n  margin-top: 24px;\n}\n\n.info-page__block h2 {\n  margin: 0 0 8px 0;\n  font-family: 'Neucha', cursive;\n  font-size: 34px;\n  font-weight: 400;\n}\n\n.info-page__block p {\n  margin: 0 0 8px 0;\n}\n\n.info-page__block p:last-child {\n  margin-bottom: 0;\n}\n\n.info-page__block a {\n  color: #fc761f;\n}\n\n.info-page__list {\n  margin: 0;\n  padding-left: 20px;\n  display: grid;\n  gap: 6px;\n}\n\n@media (max-width: 768px) {\n  .info-page {\n    padding-top: 20px;\n    padding-bottom: 28px;\n  }\n\n  .info-page__card {\n    border-radius: 14px;\n    padding: 18px 16px;\n  }\n\n  .info-page__title {\n    font-size: 38px;\n    margin-bottom: 12px;\n  }\n\n  .info-page__motto {\n    font-size: 18px;\n  }\n\n  .info-page__block h2 {\n    font-size: 30px;\n  }\n}\n\n@media (max-width: 430px) {\n  .info-page__title {\n    font-size: 32px;\n  }\n\n  .info-page__motto {\n    font-size: 16px;\n  }\n\n  .info-page__block h2 {\n    font-size: 26px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
